/* SFD2 storefront behaviour: PDP size picker, gallery dots, add-to-bag via Shopify /cart/add.js.
   No timers, no fake counts. All stock/price data comes from Liquid-rendered JSON. */
(function () {
  if (window.__sfd2Loaded) return; // sections each include this file; run once per page
  window.__sfd2Loaded = true;
  function money(cents, fmt) {
    var n = Number(cents) / 100;
    function fx(d, t, dec) { var p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? dec + p[1] : ''); }
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fx(0, ',', '.');
        case 'amount_with_comma_separator': return fx(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fx(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fx(2, "'", '.');
        default: return fx(2, ',', '.');
      }
    });
  }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Shared: refresh our counts, then ask the theme to refresh its drawer cart + header count
  // via its documented `theme:update:cart` event (assets/theme-events.js).
  var SFD2 = window.SFD2 = window.SFD2 || {};
  SFD2.syncCart = function (o) {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!(o && o.quiet)) document.querySelectorAll('[data-sfd2-bagcount]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
      document.querySelectorAll('[data-sfd2-boxbar]').forEach(function (bar) {
        var type = bar.getAttribute('data-box-type') || '', pairs = 0, boxes = 0;
        (c.items || []).forEach(function (it) { if (type && it.product_type === type) boxes += it.quantity; else pairs += it.quantity; });
        var parts = [];
        if (pairs) parts.push(pairs + (pairs === 1 ? ' pair' : ' pairs'));
        if (boxes) parts.push(boxes + (boxes === 1 ? ' box' : ' boxes'));
        var el = bar.querySelector('[data-boxpairs]'); if (el) el.textContent = parts.join(' · ');
        bar.hidden = !c.item_count;
      });
      document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
      return c;
    }).catch(function () {});
  };
  // Add failed without a usable response (network drop or unreadable reply). The POST may already have
  // succeeded, so NEVER resubmit: re-fetch the real cart, refresh counts, and tell the shopper to check the bag.
  SFD2.unsureAdd = function (msgEl) {
    return SFD2.syncCart().then(function (c) {
      if (msgEl) msgEl.textContent = c ? "We couldn't confirm that. Check your bag before adding again." : 'Connection problem. Please try again.';
    });
  };
  // Round 15 job 26: the add-to-bag moment. After ANY successful add: the button flashes hot pink with a tick,
  // the product thumbnail arcs into the visible bag icon (~550ms), the bag bounces and its badge pops to the real
  // /cart.js count, and a confirmation panel (bottom sheet on phone, top-right card on desktop) stays ~4s.
  // prefers-reduced-motion: no flight, no bounce, just the panel + count.
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduced() { return !!(RM && RM.matches); }
  function sized(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function visibleBag() {
    var best = null;
    document.querySelectorAll('[data-sfd2-bagcount]').forEach(function (c) {
      var a = c.parentNode; if (!a || best) return;
      var r = a.getBoundingClientRect();
      if (r.width && r.height && r.bottom > 0 && r.top < window.innerHeight && getComputedStyle(a).visibility !== 'hidden') best = a;
    });
    return best;
  }
  var toast = null, toastTimer = null, toastFocus = null;
  function buildToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'sfd2 sfd2-addwrap';
    toast.innerHTML = '<div class="addtoast" role="status" aria-live="polite" aria-atomic="true" data-addtoast>' +
      '<button type="button" class="ico at-x" data-at-close aria-label="Close">✕</button>' +
      '<div class="at-row"><img data-at-img alt="" width="72" height="90"><div class="at-txt">' +
      '<p class="at-h h">In the bag!</p><p class="at-name" data-at-name></p><p class="at-meta"><span data-at-size></span><b data-at-price></b></p></div></div>' +
      '<div class="at-btns"><a class="btn ghost" href="' + ROOT + 'cart">View bag <span data-at-count></span></a><a class="btn" href="' + ROOT + 'checkout">Checkout</a></div></div>';
    document.body.appendChild(toast);
    toast.addEventListener('click', function (e) { if (e.target.closest('[data-at-close]')) hideToast(); });
    toast.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toast.addEventListener('mouseleave', function () { armToast(); });
    toast.addEventListener('focusin', function () { clearTimeout(toastTimer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toast.classList.contains('show')) hideToast(); });
    document.addEventListener('pointerdown', function (e) { if (toast.classList.contains('show') && !e.target.closest('[data-addtoast]')) hideToast(); }, true);
    return toast;
  }
  function armToast() { clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 4200); }
  function hideToast() { if (!toast) return; clearTimeout(toastTimer); var p = toast.querySelector('[data-addtoast]'); var had = p.contains(document.activeElement); toast.classList.remove('show'); if (had && toastFocus) try { toastFocus.focus(); } catch (e) {} }
  function showToast(it, cart) {
    buildToast();
    var img = toast.querySelector('[data-at-img]'), src = it.image || (it.featured_image && it.featured_image.url) || '';
    if (src) { img.src = sized(src, 200); img.hidden = false; } else img.hidden = true;
    toast.querySelector('[data-at-name]').textContent = it.product_title || it.title || '';
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    toast.querySelector('[data-at-size]').textContent = vt ? 'Size ' + vt.split(' / ')[0] + ' · ' : '';
    var fmt = (window.theme && theme.moneyFormat) || toastFmt || '${{amount}}';
    toast.querySelector('[data-at-price]').textContent = money(it.final_price != null ? it.final_price : it.price, fmt).replace(/([.,])00(?!\d)/, '');
    toast.querySelector('[data-at-count]').textContent = cart && cart.item_count ? '(' + cart.item_count + ')' : '';
    var hdr = document.querySelector('.sfd2 .hdr'), hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
    toast.style.setProperty('--sfd2-hdr-b', Math.max(0, Math.round(hb)) + 'px');
    toast.classList.remove('show'); void toast.offsetWidth; toast.classList.add('show');
    armToast();
  }
  var toastFmt = '';
  function pop(el, cls, ms) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }
  function flyTo(fromEl, src, bag) {
    if (reduced() || !fromEl || !bag || !src || !document.body.animate) return 0;
    var a = fromEl.getBoundingClientRect(), b = bag.getBoundingClientRect();
    if (!a.width) return 0;
    var s = 72, x0 = a.left + a.width / 2 - s / 2, y0 = a.top + a.height / 2 - s / 2, x1 = b.left + b.width / 2 - s / 2, y1 = b.top + b.height / 2 - s / 2;
    var f = document.createElement('div'); f.className = 'sfd2 sfd2-fly'; f.setAttribute('aria-hidden', 'true');
    f.innerHTML = '<img alt="" src="' + sized(src, 160).replace(/"/g, '&quot;') + '">';
    f.style.left = x0 + 'px'; f.style.top = y0 + 'px';
    document.body.appendChild(f);
    var dx = x1 - x0, dy = y1 - y0, lift = Math.min(-80, dy * 0.25 - 80); // arc: rise first, then drop into the bag
    var anim = f.animate([
      { transform: 'translate(0,0) scale(.6) rotate(0)', opacity: 0 },
      { transform: 'translate(' + dx * 0.15 + 'px,' + lift * 0.6 + 'px) scale(1.15) rotate(-8deg)', opacity: 1, offset: 0.18 },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (lift + dy * 0.2) + 'px) scale(.9) rotate(10deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.22) rotate(-6deg)', opacity: 0.85 }
    ], { duration: 560, easing: 'cubic-bezier(.45,.05,.55,1)', fill: 'forwards' });
    anim.onfinish = function () { f.remove(); };
    setTimeout(function () { if (f.parentNode) f.remove(); }, 1200);
    return 540;
  }
  function tickBtns(btns) {
    (btns || []).forEach(function (b) {
      if (!b) return;
      if (b._sfd2html == null) b._sfd2html = b.innerHTML;
      var small = b.classList.contains('qadd');
      b.innerHTML = small ? '<span aria-hidden="true">✓</span>' : '✓ Added'; b.classList.add('is-added');
      clearTimeout(b._sfd2t);
      b._sfd2t = setTimeout(function () { b.classList.remove('is-added'); b.innerHTML = b._sfd2html; b._sfd2html = null; }, 1600);
    });
  }
  // opts: { item: line item from /cart/add.js, fromEl: element the thumbnail flies from, btns: buttons to tick, fmt }
  SFD2.celebrate = function (opts) {
    var it = opts.item || {}; if (opts.fmt) toastFmt = opts.fmt;
    toastFocus = opts.btns && opts.btns[0];
    tickBtns(opts.btns);
    var bag = visibleBag();
    var wait = flyTo(opts.fromEl, it.image || '', bag);
    var cartP = SFD2.syncCart({ quiet: true });
    setTimeout(function () {
      cartP.then(function (c) {
        if (c) document.querySelectorAll('[data-sfd2-bagcount]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; if (!reduced()) pop(el, 'is-pop', 500); });
        if (bag && !reduced()) pop(bag, 'is-bounce', 500);
        showToast(it, c);
      });
    }, wait);
  };
  SFD2.addError = function (msgEl, text) { if (!msgEl) return; msgEl.classList.add('is-err'); msgEl.textContent = text; };
  // Size memory: last size the shopper picked (US part, e.g. "7"), on this device only. Used to PRE-SELECT
  // an in-stock size on the product page / quick-add sheet. Never adds to bag.
  var SIZE_KEY = 'sfd2-size';
  SFD2.rememberSize = function (size) { try { if (size) localStorage.setItem(SIZE_KEY, String(size)); } catch (e) {} };
  SFD2.lastSize = function () { try { return localStorage.getItem(SIZE_KEY) || ''; } catch (e) { return ''; } };
  // Gallery dots
  document.querySelectorAll('.sfd2 [data-gallery]').forEach(function (g) {
    var dots = g.parentNode.querySelectorAll('[data-dot]');
    if (!dots.length) return;
    g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / g.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }, { passive: true });
  });
  // PDP
  document.querySelectorAll('[data-sfd2-pdp]').forEach(function (root) {
    var dataEl = root.querySelector('[data-sfd2-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var input = root.querySelector('input[name="id"]');
    var sigEl = root.querySelector('[data-low-stock]');
    var btns = root.querySelectorAll('[data-atb]'); // round 13: in-page button + phone sticky-bar button
    var btn = btns[0];
    var msg = root.querySelector('[data-atb-msg]');
    if (!btn) return; // fully sold out: no add button, nothing to wire
    var chosen = root.querySelectorAll('[data-chosen-size]');
    var priceEls = root.querySelectorAll('[data-price]');
    var cmpEl = root.querySelector('[data-compare]'), cmpAmt = root.querySelector('[data-compare-amt]');
    // money_without_trailing_zeros, like the Liquid: "$14.00" -> "$14", "$8.50" stays.
    function moneyNz(c) { return money(c, data.money_format).replace(/([.,])00(?!\d)/, ''); }
    function setBtns(fn) { btns.forEach(fn); }
    function select(v, auto) {
      input.value = v.id;
      root.querySelectorAll('[data-variant-id]').forEach(function (b) {
        var on = String(b.getAttribute('data-variant-id')) === String(v.id);
        b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      chosen.forEach(function (c) { c.textContent = v.title; });
      priceEls.forEach(function (p) { p.textContent = moneyNz(v.price); });
      if (cmpEl) { var hasCmp = v.compare_at_price > v.price; cmpEl.hidden = !hasCmp; if (cmpAmt) cmpAmt.textContent = hasCmp ? moneyNz(v.compare_at_price) : ''; }
      var saveEl = root.querySelector('[data-save]'), saveAmt = root.querySelector('[data-save-amt]');
      if (saveEl) { var hs = v.compare_at_price > v.price; saveEl.hidden = !hs; if (saveAmt) saveAmt.textContent = hs ? moneyNz(v.compare_at_price - v.price) : ''; }
      // Apparel option groups + colour-bound made-to-order box (full-site pass)
      root.querySelectorAll('[data-opt-rest]').forEach(function (b) { var on = b.getAttribute('data-opt-rest') === v.rest; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-opt-size]').forEach(function (b) {
        var s = b.getAttribute('data-opt-size'), on = s === v.size;
        var ok = data.variants.some(function (x) { return x.rest === v.rest && x.size === s && x.available; });
        b.classList.toggle('on', on); b.classList.toggle('out', !ok); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (ok) { b.removeAttribute('aria-disabled'); b.removeAttribute('aria-label'); } else { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-label', 'Size ' + s + ' sold out'); }
      });
      root.querySelectorAll('[data-chosen-rest]').forEach(function (c) { c.textContent = v.rest.replace(/\|$/, '').split('|').join(' / '); });
      root.querySelectorAll('[data-mto-only]').forEach(function (m) { m.hidden = v.rest.toLowerCase().replace(/[^a-z0-9]+/g, '-').indexOf(m.getAttribute('data-mto-only')) < 0; });
      root.querySelectorAll('[data-eu]').forEach(function (e) { e.textContent = v.eu || ''; var w = e.closest('[data-eu-wrap]'); if (w) w.hidden = !v.eu; });
      // Member price (Joe 2026-10-15): Shopify rounds the discount DOWN to the cent (draftOrderCalculate check), so
      // price - floor(price x rate / 100), same as snippets/sfd2-member-price.liquid.
      root.querySelectorAll('[data-member-price]').forEach(function (m) {
        var rate = parseInt(m.getAttribute('data-rate'), 10);
        if (rate > 0 && rate < 100) m.textContent = moneyNz(v.price - Math.floor(v.price * rate / 100));
      });
      if (sigEl) {
        // Round 13: only when the chosen size is tracked and has 1..low_max (2) left. Unknown or more = nothing.
        var q = v.inventory_quantity, max = data.low_max || 0;
        if (max > 0 && v.tracked && v.available && q > 0 && q <= max) {
          sigEl.textContent = (data.variants.length > 1 ? data.low_text : data.low_text_single).replace('[n]', q).replace('[s]', v.title); sigEl.hidden = false;
        } else { sigEl.hidden = true; }
      }
      setBtns(function (b) { b.disabled = !v.available; b.textContent = v.available ? data.atb_text : data.soldout_text; });
      if (history.replaceState && data.update_url && !auto) { // keep any other query params (e.g. tracking)
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    }
    root.querySelectorAll('[data-variant-id]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        var id = b.getAttribute('data-variant-id');
        var v = data.variants.filter(function (x) { return String(x.id) === id; })[0];
        if (v) { select(v); if (v.size) SFD2.rememberSize(v.size); }
      });
    });
    root.querySelectorAll('[data-opt-rest],[data-opt-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = data.variants.filter(function (x) { return String(x.id) === String(input.value); })[0] || data.variants[0];
        var isSize = b.hasAttribute('data-opt-size');
        if (isSize && b.getAttribute('aria-disabled') === 'true') return;
        var rest = isSize ? cur.rest : b.getAttribute('data-opt-rest'), size = isSize ? b.getAttribute('data-opt-size') : cur.size;
        var v = data.variants.filter(function (x) { return x.rest === rest && x.size === size; })[0];
        if (!isSize && (!v || !v.available)) v = data.variants.filter(function (x) { return x.rest === rest && x.available; })[0] || v;
        if (v) { select(v); if (v.size) SFD2.rememberSize(v.size); }
      });
    });
    // Pre-select the remembered size only if: memory on, no explicit ?variant= in the URL, and that size is
    // in stock for this product (same other options, e.g. colour, as the current variant).
    var last = data.size_memory ? SFD2.lastSize() : '';
    if (last && !/[?&]variant=/.test(location.search)) {
      var cur = data.variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
      if (!cur || cur.size !== last) {
        var match = data.variants.filter(function (x) { return x.available && x.size === last && x.rest === (cur ? cur.rest : x.rest); })[0];
        if (match) select(match, true);
      }
    }
    var form = root.querySelector('form[data-sfd2-atc]');
    if (form && window.fetch) form.addEventListener('submit', function (e) {
      e.preventDefault();
      setBtns(function (b) { b.disabled = true; });
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { SFD2.addError(msg, res.j.description || res.j.message || 'Could not add that pair.'); return; }
          msg.classList.remove('is-err'); msg.textContent = '';
          var it = (res.j.items && res.j.items[0]) || res.j;
          var vis = Array.prototype.filter.call(btns, function (b) { return b.getBoundingClientRect().width > 0 && !(b.closest('[data-sfd2-stickybar]') && !b.closest('[data-sfd2-stickybar]').classList.contains('show')); });
          var from = root.querySelector('[data-gallery] img') || root.querySelector('img');
          SFD2.celebrate({ item: it, fromEl: (from && from.getBoundingClientRect().bottom > 0) ? from : (vis[0] || btn), btns: Array.prototype.slice.call(btns), fmt: data.money_format });
        })
        .catch(function () { msg.classList.add('is-err'); return SFD2.unsureAdd(msg); })
        .finally(function () { setBtns(function (b) { b.disabled = false; }); });
    });
    // Round 13 step 3: phone sticky Add-to-bag bar. Shown ONLY once the in-page buy row has scrolled up past the
    // top of the screen (so it never covers the title, price or sizes); hidden again when the row comes back.
    var bar = root.querySelector('[data-sfd2-stickybar]'), buy = root.querySelector('[data-sfd2-buy]');
    if (bar && buy) {
      var mq = window.matchMedia('(max-width: 1023px)');
      var showBar = function (on) {
        on = on && mq.matches;
        bar.classList.toggle('show', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
        var sb = bar.querySelector('[data-atb]'); if (sb) sb.tabIndex = on ? 0 : -1;
        document.documentElement.classList.toggle('sfd2-bar-on', on);
      };
      // Scroll check (rAF-throttled), not IntersectionObserver: a jump from below the row straight to above it (or back)
      // never changes "intersecting", so an observer can leave the bar showing at the top of the page.
      var ticking = false, last = null;
      var check = function () {
        ticking = false;
        // Round 13 (Jin, Astra r6): also shown while the buy row is still BELOW the screen, so the first phone screen
        // always has an Add to bag (the page reserves space via .sfd2-bar-on).
        // Joe 2026-10-15 spacing pass: the bar must never sit on top of the first screen's content, so it now shows only
        // once the in-page Add to bag has scrolled up out of view.
        var hb = document.querySelector('.hdr'); var top = hb ? Math.max(0, hb.getBoundingClientRect().bottom) : 0;
        var r = buy.getBoundingClientRect(); var on = r.bottom < top; // only once the in-page button is fully under the header
        if (on !== last) { last = on; showBar(on); }
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      check();
    }
  });
  // Cart page: upgrade the /cart/change links (+ / − / Remove) to AJAX + Section Rendering.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sfd2-change]');
    if (!a || !window.fetch) return;
    var root = a.closest('[data-sfd2-cart]');
    if (!root) return;
    e.preventDefault();
    if (root.classList.contains('is-busy')) return;
    var sid = root.getAttribute('data-section-id');
    var msg = root.querySelector('[data-sfd2-cart-msg]');
    root.classList.add('is-busy');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: a.getAttribute('data-key'), quantity: Number(a.getAttribute('data-qty')), sections: [sid], sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { root.classList.remove('is-busy'); if (msg) msg.textContent = res.j.description || res.j.message || 'Could not update your bag.'; return; }
        var html = res.j.sections && res.j.sections[sid];
        if (!html) { location.reload(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sfd2-cart]');
        if (!fresh) { location.reload(); return; }
        // Keep the already-initialised express checkout buttons (Shopify injects them once).
        var oldDyn = root.querySelector('.sfd2-dyn'), newDyn = fresh.querySelector('.sfd2-dyn');
        if (oldDyn && newDyn) newDyn.parentNode.replaceChild(oldDyn, newDyn);
        root.className = fresh.className;
        root.innerHTML = fresh.innerHTML;
        var m2 = root.querySelector('[data-sfd2-cart-msg]');
        if (m2) m2.textContent = Number(a.getAttribute('data-qty')) === 0 ? 'Removed from your bag.' : 'Bag updated.';
        SFD2.syncCart();
      })
      .catch(function () { location.href = a.href; });
  });
  // Quick-add size sheet (cards). Real variants from /products/<handle>.js, add via /cart/add.js.
  // No JS -> the + is a plain link to the product page. Network failure -> normal /cart/add form post.
  var sheetRoot = null, sheetState = null, lastFocus = null;
  function el(tag, attrs, text) { var e = document.createElement(tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (text) e.textContent = text; return e; }
  function buildSheet() {
    if (sheetRoot) return sheetRoot;
    sheetRoot = el('div', { 'class': 'sfd2', 'data-sfd2-sheet': '' });
    sheetRoot.innerHTML = '<div class="sheet-bg" data-s-close></div>' +
      '<div class="sheet" role="dialog" data-sfd2-qadd-sheet aria-modal="true" aria-labelledby="sfd2-sheet-title" aria-hidden="true" inert>' +
      '<div class="sheet-top"><img data-s-img alt="" width="64" height="80"><div style="flex:1;min-width:0"><p id="sfd2-sheet-title" style="font-weight:500"></p><p class="price"><span class="big" data-s-price></span></p></div>' +
      '<button type="button" class="ico" data-s-close aria-label="Close">✕</button></div>' +
      '<p class="sub" style="margin-bottom:12px" data-s-pick>Pick your size</p><div class="sizes" data-s-sizes></div>' +
      '<p class="legend" style="padding:12px 0 0" data-s-legend>Struck sizes are sold out.</p>' +
      '<p class="sfd2-msg" role="status" data-s-msg></p>' +
      '<button type="button" class="btn full" data-s-add style="margin-top:8px" disabled>Add to bag</button></div>';
    document.body.appendChild(sheetRoot);
    sheetRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-s-close]')) { closeSheet(); return; }
      var b = e.target.closest('[data-s-variant]');
      if (b && !b.disabled) { pickVariant(b.getAttribute('data-s-variant')); if (sheetState && sheetState.variant && sheetState.sizeOpt) SFD2.rememberSize(usPart(sheetState.variant[sheetState.sizeOpt])); }
      if (e.target.closest('[data-s-add]')) addFromSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (!sheetState) return;
      if (e.key === 'Escape') closeSheet();
      if (e.key === 'Tab') { // keep focus inside the dialog
        var f = sheetRoot.querySelectorAll('.sheet button:not([disabled])'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    return sheetRoot;
  }
  function q(s) { return sheetRoot.querySelector(s); }
  // Round 15 job 27: quick-add sheet matches every other surface: "$14.00" -> "$14", "$8.50" stays.
  function moneyNoZeros(c, fmt) { return money(c, fmt).replace(/([.,])00(?!\d)/, ''); }
  function pickVariant(id) {
    var v = sheetState.product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v || !v.available) return;
    sheetState.variant = v;
    sheetRoot.querySelectorAll('[data-s-variant]').forEach(function (b) { var on = b.getAttribute('data-s-variant') === String(v.id); b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    q('[data-s-price]').textContent = moneyNoZeros(v.price, sheetState.fmt);
    q('[data-s-add]').disabled = false;
  }
  function openSheet(link) {
    buildSheet(); lastFocus = link;
    var url = link.getAttribute('href').split('?')[0].split('#')[0];
    sheetState = { url: url, fmt: link.getAttribute('data-money-format'), link: link };
    q('#sfd2-sheet-title').textContent = link.getAttribute('data-title') || '';
    q('[data-s-sizes]').innerHTML = ''; q('[data-s-msg]').textContent = 'Loading sizes…'; q('[data-s-price]').textContent = '';
    q('[data-s-add]').disabled = true; q('[data-s-img]').removeAttribute('src');
    var sh = q('.sheet'); sh.removeAttribute('inert'); sh.setAttribute('aria-hidden', 'false');
    sh.classList.add('open'); q('.sheet-bg').classList.add('open');
    q('[data-s-close]:not(.sheet-bg)').focus();
    return fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
      if (!sheetState || sheetState.link !== link) return;
      sheetState.product = p;
      if (p.featured_image) { var src = p.featured_image; q('[data-s-img]').src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
      var only = p.variants.length === 1;
      q('[data-s-pick]').hidden = only; q('[data-s-legend]').hidden = only || p.variants.every(function (v) { return v.available; });
      var box = q('[data-s-sizes]');
      if (!only) p.variants.forEach(function (v) {
        var b = el('button', { type: 'button', 'class': 'sz' + (v.available ? '' : ' out'), 'data-s-variant': String(v.id), 'aria-pressed': 'false' }, v.title);
        if (!v.available) { b.disabled = true; b.setAttribute('aria-label', 'Size ' + v.title + ' sold out'); }
        box.appendChild(b);
      });
      q('[data-s-msg]').textContent = '';
      var avail = p.variants.filter(function (v) { return v.available; });
      if (!avail.length) { q('[data-s-msg]').textContent = 'Sold out.'; return; }
      if (only) pickVariant(avail[0].id);
      else {
        q('[data-s-price]').textContent = moneyNoZeros(avail[0].price, sheetState.fmt) + (p.price_varies ? '+' : '');
        // Size memory: find the size option; pre-select only when exactly one IN-STOCK variant has the remembered size.
        (p.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (!sheetState.sizeOpt && /size/i.test(n || '')) sheetState.sizeOpt = 'option' + ((o && o.position) || i + 1); });
        var last = SFD2.lastSize(), pre = null;
        if (last && sheetState.sizeOpt) {
          var m = avail.filter(function (v) { return usPart(v[sheetState.sizeOpt]) === last; });
          if (m.length === 1) pre = m[0];
        }
        if (pre) pickVariant(pre.id);
        var f = pre ? box.querySelector('[data-s-variant="' + pre.id + '"]') : box.querySelector('.sz:not([disabled])'); if (f) f.focus();
      }
    }).catch(function () { location.href = link.getAttribute('href'); });
  }
  function closeSheet() {
    if (!sheetRoot) return;
    var sh = q('.sheet'); sh.classList.remove('open'); q('.sheet-bg').classList.remove('open');
    sh.setAttribute('aria-hidden', 'true'); sh.setAttribute('inert', '');
    sheetState = null; if (lastFocus) lastFocus.focus();
  }
  function addFromSheet() {
    if (!sheetState || !sheetState.variant) return;
    var v = sheetState.variant, title = sheetState.product.title, btn = q('[data-s-add]'), msg = q('[data-s-msg]');
    btn.disabled = true; msg.textContent = 'Adding…';
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.disabled = false; SFD2.addError(msg, res.j.description || res.j.message || 'Could not add that pair.'); return; }
        msg.classList.remove('is-err'); msg.textContent = '';
        var it = (res.j.items && res.j.items[0]) || res.j, link = sheetState.link, fmt = sheetState.fmt;
        if (!it.image && sheetState.product.featured_image) it.image = sheetState.product.featured_image;
        closeSheet();
        // fly from the card's photo (falls back to the + itself), tick the + button
        var card = link.closest('.sfd2-card, .card, li, article'), ph = card && card.querySelector('img');
        SFD2.celebrate({ item: it, fromEl: ph || link, btns: [link], fmt: fmt });
      })
      .catch(function () { btn.disabled = false; msg.classList.add('is-err'); return SFD2.unsureAdd(msg); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sfd2-qadd]');
    if (!a || !window.fetch) return;
    e.preventDefault(); openSheet(a);
  });
  // Size chips. Storefront-filter route = plain GET form (no JS needed). Client route (no size filter in
  // Search & Discovery): chips are hidden until here, sorted numerically, de-duplicated by US size, and
  // hide cards on this page whose in-stock sizes (data-sizes, real option values) don't include it.
  function usPart(v) { return String(v || '').split(' / ')[0].trim(); }
  // Round 15 job 27 (M2): apparel sizes in wearing order (XS..3XL); shoe sizes stay numeric; unknown tokens last.
  var APPAREL = { XXS: 1, XS: 2, S: 3, M: 4, L: 5, XL: 6, XXL: 7, '2XL': 7, XXXL: 8, '3XL': 8, '4XL': 9, '5XL': 10 };
  function sizeNum(v) {
    var t = String(v || '').trim().toUpperCase();
    if (APPAREL.hasOwnProperty(t)) return 1000 + APPAREL[t];
    if (/^\d+(\.\d+)?$/.test(t)) return parseFloat(t);
    var n = parseFloat(t); return isNaN(n) ? Infinity : n;
  }
  document.querySelectorAll('.sfd2 [data-sfd2-sizechips]').forEach(function (bar) {
    var scope = bar.closest('.sfd2');
    var cards = scope.querySelectorAll('.sfd2-card[data-sizes]');
    var status = scope.querySelector('[data-sfd2-size-status]');
    var seen = {}, chips = [];
    bar.querySelectorAll('[data-sfd2-size]').forEach(function (c) {
      var k = c.getAttribute('data-sfd2-size');
      if (seen[k]) { c.parentNode.removeChild(c); return; }
      seen[k] = true; chips.push(c);
    });
    chips.sort(function (a, b) {
      var x = sizeNum(a.getAttribute('data-sfd2-size')), y = sizeNum(b.getAttribute('data-sfd2-size'));
      return x === y ? a.textContent.localeCompare(b.textContent) : x - y;
    }).forEach(function (c) { bar.appendChild(c); });
    if (chips.length < 2) return; // one size = nothing to filter
    bar.hidden = false;
    var sizenote = scope.querySelector('[data-sfd2-sizenote]'); if (sizenote) sizenote.hidden = false;
    var countEl = scope.querySelector('[data-sfd2-count-label]');
    function unitWord(n) { var u = (countEl && countEl.getAttribute('data-unit')) || 'pair'; return n === 1 ? u : u + 's'; }
    var countOrig = countEl ? countEl.textContent : '';
    bar.addEventListener('click', function (e) {
      var c = e.target.closest('button.chip'); if (!c) return;
      var size = c.getAttribute('data-sfd2-size'); // null for "All sizes"
      bar.querySelectorAll('button.chip').forEach(function (b) { b.setAttribute('aria-pressed', b === c ? 'true' : 'false'); });
      var shown = 0;
      cards.forEach(function (card) {
        // Boxes (data-box) are hidden while a size is chosen: they are not a single size.
        var ok = !size || (!card.hasAttribute('data-box') && card.getAttribute('data-sizes').split('|').map(usPart).indexOf(size) > -1);
        card.hidden = !ok; if (ok) shown++;
      });
      // Test hook (round 6): read-only mirrors of the chosen size and visible pairs on [data-sfd2-count].
      var hook = scope.querySelector('[data-sfd2-count]');
      if (hook) {
        if (size) { hook.setAttribute('data-sfd2-count-size', size); hook.setAttribute('data-sfd2-count-shown', String(shown)); }
        else { hook.removeAttribute('data-sfd2-count-size'); hook.removeAttribute('data-sfd2-count-shown'); }
      }
      if (countEl) countEl.textContent = !size ? countOrig : shown + ' ' + unitWord(shown) + ' in size ' + size + (status && status.getAttribute('data-page-note') ? ' on this page' : '');
      if (status) {
        var note = status.getAttribute('data-page-note');
        status.textContent = !size ? '' : (shown ? shown + ' ' + unitWord(shown) + ' in size ' + size + (note ? ' ' + note : '') + '.'
          : 'No ' + unitWord(0) + ' in size ' + size + (note ? ' ' + note : '') + ' right now.');
        // The visible count already says it; keep the status for screen readers unless nothing matched.
        status.classList.toggle('visually-hidden', !!(size && shown && countEl));
      }
      if (size && SFD2.rememberSize) SFD2.rememberSize(size);
      // Round 13: while a size is chosen every matching pair shows (the "Load more" batch limit is lifted).
      var grid = scope.querySelector('[data-sfd2-grid]');
      if (grid) grid.classList.toggle('filtering', !!size);
      var more = scope.querySelector('[data-sfd2-more]');
      if (more) more.hidden = !!size || !grid.querySelector('[data-sfd2-more-item]:not(.shown)');
    });
  });
  // Round 13 step 2: "Load more pairs". The collection renders every pair (in stock first, then sold out); cards past
  // the first batch sit in [data-sfd2-more-item] wrappers. Hidden only once this script runs (no JS = all show).
  document.querySelectorAll('.sfd2 [data-sfd2-grid]').forEach(function (grid) {
    var scope = grid.closest('.sfd2'), btn = scope.querySelector('[data-sfd2-more]'), pageLink = scope.querySelector('[data-sfd2-more-page]');
    if (!btn) return;
    var step = parseInt(grid.getAttribute('data-reveal'), 10) || 24;
    function rest() { return grid.querySelectorAll('[data-sfd2-more-item]:not(.shown)'); }
    grid.setAttribute('data-more-ready', '');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var r = rest(), first = null;
      for (var i = 0; i < Math.min(step, r.length); i++) {
        r[i].classList.add('shown');
        r[i].querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
        if (!first) first = r[i].querySelector('a.nm');
      }
      if (!rest().length) { btn.hidden = true; if (pageLink) pageLink.hidden = false; }
      if (first) first.focus({ preventScroll: true });
    });
  });
  document.addEventListener('click', function (e) { // storefront-filter route: remember the chosen size too
    var c = e.target.closest && e.target.closest('.sfd2-sizeform [data-sfd2-size]');
    if (c && SFD2.rememberSize) SFD2.rememberSize(c.getAttribute('data-sfd2-size'));
  });
  // Inline field errors (VIP signup, round 5): replace the browser tooltip with the inline message.
  // Forms holding a [data-sfd2-err-msg] field get novalidate (JS only, so no-JS keeps native validation);
  // on submit each such field is checked, the message goes into its aria-describedby live region
  // (role=alert + aria-live), aria-invalid is set and the first bad field is focused. Cleared once valid.
  function errBox(f) { return document.getElementById(f.getAttribute('aria-describedby') || ''); }
  function showErr(f) { var b = errBox(f); if (b) { b.hidden = false; b.textContent = f.getAttribute('data-sfd2-err-msg'); } f.setAttribute('aria-invalid', 'true'); }
  function clearErr(f) { var b = errBox(f); if (b) b.textContent = ''; f.removeAttribute('aria-invalid'); }
  function armForms() {
    document.querySelectorAll('[data-sfd2-err-msg]').forEach(function (f) { if (f.form) f.form.noValidate = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armForms); else armForms();
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.querySelectorAll) return;
    var bad = null;
    form.querySelectorAll('[data-sfd2-err-msg]').forEach(function (f) {
      if (f.checkValidity()) { clearErr(f); } else { showErr(f); if (!bad) bad = f; }
    });
    if (bad) { e.preventDefault(); e.stopImmediatePropagation(); bad.focus(); }
  }, true);
  document.addEventListener('input', function (e) {
    var f = e.target; if (!f || !f.hasAttribute || !f.hasAttribute('data-sfd2-err-msg') || !f.checkValidity()) return;
    clearErr(f);
  });
  // Links styled as buttons (role="button": quick-add +, cart − / + / Remove) also activate with Space.
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var a = e.target && e.target.closest && e.target.closest('.sfd2 a[role="button"]');
    if (!a || a !== e.target) return;
    e.preventDefault(); a.click();
  });
  // Product rails: show back/next buttons only when the row really overflows; disable at the ends.
  document.querySelectorAll('[data-rail-nav]').forEach(function (nav) {
    var rail = document.getElementById(nav.getAttribute('data-rail-nav')); if (!rail) return;
    var prev = nav.querySelector('[data-rail-prev]'), next = nav.querySelector('[data-rail-next]');
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }
    function go(dir) { rail.scrollBy({ left: dir * Math.max(rail.clientWidth * 0.8, 200), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
  if (!document.querySelector('[data-sfd2-live]')) { var live = el('div', { 'class': 'sfd2', 'aria-live': 'polite' }); live.innerHTML = '<p class="visually-hidden" data-sfd2-live></p>'; document.body.appendChild(live); }
  // Round 5 (REVIEW-4B minor), round 6 (REVIEW-5 §3): "The amount on the checkout button includes it." only when
  // ShipInsure is present. Signals (app/embed only, never the checkout button's text, which the theme may rewrite):
  //  1. a <script> whose src contains "shipinsure" (present at load or injected later by the embed);
  //  2. the widget rendering into our mount [data-sfd2-si-mount] (sections/sfd2-main-cart.liquid);
  //  3. an element carrying data-sfd2-si-present (explicit hook, e.g. if the app's embed exposes one).
  // Watched until window load + 15 s, then the observer stops; no signal = the sentence stays hidden.
  (function () {
    var bits = document.querySelectorAll('[data-sfd2-si-btn]'); if (!bits.length) return;
    var done = false, mo = null;
    function show() { if (done) return; done = true; bits.forEach(function (b) { b.hidden = false; }); if (mo) mo.disconnect(); }
    function check() {
      if (done) return;
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) { if (/shipinsure/i.test(scripts[i].src || '')) { show(); return; } }
      var mounts = document.querySelectorAll('[data-sfd2-si-mount]');
      for (var j = 0; j < mounts.length; j++) { if (mounts[j].children.length) { show(); return; } }
      if (document.querySelector('[data-sfd2-si-present]')) show();
    }
    if (window.MutationObserver) {
      mo = new MutationObserver(function (recs) { for (var k = 0; k < recs.length; k++) { if (recs[k].addedNodes.length || recs[k].type === 'attributes') { check(); return; } } });
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-sfd2-si-present', 'src'] });
    }
    check(); window.addEventListener('load', check);
    setTimeout(function () { check(); if (mo) mo.disconnect(); }, 15000);
  })();
  // Round 13 (Jin): the job-3 sync that copied ShipInsure's checkout-button amount into the bag totals was removed.
  // On a real bag it fed back on itself (a $14 pair showed "Package protection $9.80", Subtotal $23.80): the theme
  // rewrote the Subtotal, ShipInsure re-priced off it and rewrote the button, and so on. The bag now always shows the
  // real item subtotal from Liquid and the plain ShipInsure note; whether protection is on by default is Joe's call
  // (2026-10-09). SFD2.parseMoneyCents is kept for any later, non-looping use.
  SFD2.parseMoneyCents = function (text) {
    var m = String(text || '').match(/\$\s?(\d{1,3}(?:,\d{3})*|\d+)(?:\.(\d{2}))?(?!.*\$\s?\d)/);
    if (!m) return null;
    return parseInt(m[1].replace(/,/g, ''), 10) * 100 + (m[2] ? parseInt(m[2], 10) : 0);
  };
  // Round 13 (Jin, Astra r3 #1): READ-ONLY protection line. When the ShipInsure script is on the page and its rewritten
  // checkout button shows an amount above the bag subtotal (by at most $10, a sanity cap), the bag shows that difference
  // as "Package protection (optional) +$X" in its own row. The theme never writes the subtotal or the button, so the app
  // has nothing of ours to re-price from (the earlier sync looped: $14 bag -> "+$9.80"). Runs only when the button text changes.
  (function () {
    if (!document.querySelector('[data-sfd2-cart]')) return;
    var last = null;
    function siOn() { var s = document.getElementsByTagName('script'); for (var i = 0; i < s.length; i++) { if (/shipinsure/i.test(s[i].src || '')) return true; } return false; }
    function check() {
      var btn = document.querySelector('[data-sfd2-cart] button[name="checkout"]');
      var dl = document.querySelector('[data-sfd2-totals]');
      if (!btn || !dl) return;
      var t = btn.textContent; if (t === last) return; last = t;
      var row = dl.querySelector('[data-sfd2-si-row]'), amt = dl.querySelector('[data-sfd2-si-amt]');
      if (!row || !amt) return;
      var base = parseInt(dl.getAttribute('data-sfd2-subtotal'), 10), fmt = dl.getAttribute('data-money-format') || '${{amount}}';
      var shown = siOn() && /\$/.test(fmt) ? SFD2.parseMoneyCents(t) : null;
      var diff = (shown !== null && !isNaN(base)) ? shown - base : 0;
      var buy = document.querySelector('[data-sfd2-cart] .cart-buy'), ex = document.querySelector('[data-sfd2-si-explain]');
      if (buy && !ex) { ex = document.createElement('p'); ex.className = 'legend'; ex.setAttribute('data-sfd2-si-explain', ''); ex.style.padding = '6px 0 0'; buy.insertAdjacentElement('afterend', ex); }
      var note = document.querySelector('.sfd2-si-note'); if (note) note.hidden = (diff > 0 && diff <= 1000);
      var tot = dl.querySelector('.tot'), tb = dl.querySelector('[data-sfd2-tbs]');
      if (diff > 0 && diff <= 1000) { if (!tb) { tb = document.createElement('div'); tb.className = 'tot'; tb.setAttribute('data-sfd2-tbs', ''); tb.innerHTML = '<dt>Total before shipping</dt><dd></dd>'; dl.appendChild(tb); } tb.querySelector('dd').textContent = money(shown, fmt); tb.hidden = false; if (tot && tot !== tb) tot.hidden = true; }
      else { if (tb) tb.hidden = true; if (tot && tot !== tb) tot.hidden = false; }
      if (diff > 0 && diff <= 1000) { amt.textContent = '+' + money(diff, fmt); row.hidden = false; if (ex) { ex.hidden = true; }
        var sp = document.querySelector('[data-sfd2-cart] .cart-buy .sp'); if (sp) { var tl = sp.querySelector('[data-sfd2-tot-label]'); if (!tl) { tl = document.createElement('span'); tl.setAttribute('data-sfd2-tot-label',''); tl.className = 'big'; sp.appendChild(tl); } var sm = sp.querySelector('small'); if (sm) sm.textContent = 'Total before shipping'; tl.textContent = money(shown, fmt); var orig = sp.querySelector('[data-sfd2-subtotal-out]'); if (orig) orig.style.display = 'none'; } }
      else { amt.textContent = ''; row.hidden = true; if (ex) ex.hidden = true; }
    }
    setInterval(check, 700); check();
  })();
  // Round 9 (REVIEW-8 D2/D3): below-the-fold SFD2 photos (product cards, style tiles, look tiles, price tiles) keep
  // loading="lazy" so they never compete with the hero, but once the page has loaded they are switched to eager so
  // every photo is present without scrolling (r8 renders showed empty cards: Chrome only fetches lazy images within
  // ~1250px of the viewport, and the screenshot harness never scrolls). Skipped on Save-Data / 2G connections.
  (function () {
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    function warm() {
      var imgs = document.querySelectorAll('.sfd2 img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) { if (imgs[i].closest('[data-more-ready] [data-sfd2-more-item]:not(.shown)')) continue; imgs[i].loading = 'eager'; }
    }
    function later() { if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 800 }); else setTimeout(warm, 200); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  })();
  // Tier progress (Joe 2026-10-14): the bar fills once it scrolls into view. Reduced motion / no IntersectionObserver
  // = drawn full straight away (the Liquid already sets the real width; nothing here changes a number).
  (function () {
    var RMq = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
    if ((RMq && RMq.matches) || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    function arm() {
      document.querySelectorAll('[data-sfd2-tprog]:not(.tp-anim)').forEach(function (el) {
        el.classList.add('tp-anim'); void el.offsetWidth; io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  })();
})();
